import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchNoteAttachmentBreadcrumbs } from "./noteAttachmentsSlice"
import { setWorkingAttachmentRelation } from "./workingArticleNoteRelationSlice"

export const setTargetObject = createAsyncThunk(
	"targetArticle/setTargetObject",
	async ({articleId, attachment, workspaceId}, { dispatch, rejectWithValue }) => {
		try {
			if (articleId) {
				return {id: articleId, workspaceId}
			} else if (attachment){
				await dispatch(fetchNoteAttachmentBreadcrumbs({attachment, workspaceId}))
				dispatch(setWorkingAttachmentRelation({attachmentId: attachment.id, workspaceId}))

				return { id: "attachment/" + attachment.id, workspaceId }
			}
		} catch (error) {
			return rejectWithValue(error.message)
		}
	}
)


export const targetArticleSlice = createSlice({
	name: "targetArticle",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setTargetArticle: (state, action) => {
			const {id, workspaceId} = action.payload
			state.byWorkspace[workspaceId] = id
		},
		clearState: (state, action) => {
			state.byWorkspace[action.payload] = null
		}
	},
	extraReducers: (builder) => {
		builder.addCase(setTargetObject.fulfilled, targetArticleSlice.caseReducers.setTargetArticle)
	}
})

export const { setTargetArticle, clearState } = targetArticleSlice.actions

export const selectTargetArticle = (state, workspaceId) => state.targetArticle.byWorkspace?.[workspaceId] ?? null

export default targetArticleSlice.reducer
